export class RulesDetailModel{
  sequence: number;
  ruleId: number;
  cleansingMethod: string;
  cleansingMethodModified?: string;
  value: string;
  cleansingRuleConfigId: number;
  evaluateInfluencingTag: boolean = false;
  influencingTag: string;
  condition: string;
  cleansingQualifier: string;
}
